import React from 'react'
import AdminLogin from '../AdminDasboard/AdminLogin'

const AdminLoginPage = () => {
  return (
   <>
    <AdminLogin/>
   </>
  )
}

export default AdminLoginPage